export default __webpack_public_path__ + "static/media/archi_slider_11.0a4bba01.webp";